import { isArray } from 'lodash';

export const parseDocumenType = (documentType) => {
  if (isArray(documentType)) {
    return documentType[0]?.value;
  }
  return documentType?.value;
};
